import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial';
import { ToastController } from 'ionic-angular';

@Injectable()
export class PrintProvider {

  constructor(public btSerial:BluetoothSerial,
              public toastCtrl: ToastController){

  }

  abreToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  enableBluetooth(){
    return this.btSerial.enable();
  }  
  
  searchBluetoothPrinter(){
  //This will return a list of bluetooth devices
    return this.enableBluetooth().then(() => {  
      return this.btSerial.list(); 
    }).catch((error) => {
      console.log(error);
      this.abreToast('Falha ao ativar bluetooth, tente novamente!');
    });
  }

  connectToBluetoothPrinter(macAddress){
  //This will connect to bluetooth printer via the mac address provided
    return this.btSerial.connect(macAddress)
  }

  disconnectBluetoothPrinter(){
  //This will disconnect the current bluetooth connection
    return this.btSerial.disconnect();
  }

  //macAddress->the device's mac address 
  //data_string-> string to be printer
  sendToBluetoothPrinter(macAddress,data_string){
    this.enableBluetooth().then(() => {  
      //1. Try connecting to bluetooth printer
      this.connectToBluetoothPrinter(macAddress).subscribe(_=>{
          //2. Connected successfully
          this.btSerial.write(data_string).then(_=>{
            //3. Print successful
            //If you want to tell user print is successful,
            //handle it here
            //4. IMPORTANT! Disconnect bluetooth after printing
            this.disconnectBluetoothPrinter()
          },err=>{
            console.log(err);
          })
      },err=>{      
        console.log(err);
        this.abreToast('Falha ao conectar com a impressora, verifique se ela está ligada e tente novamente!');
      })
    }).catch((error) => {
      console.log(error);
      this.abreToast('Falha ao ativar bluetooth, tente novamente!');
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/print/print.ts